module.exports = __webpack_public_path__ + "images/5a17ae75d0b5df34623fd6159c68559f.svg";